const _NODE_DATA_OFFSET = {
  block_size: 0,
  node_type: 0,
  field: 0,
  version: 0,
  org_id: 0,
  node_id: 0,
  parent_id: 0,
  first_child: 0,
  last_child: 0,
  forward_node: 0,
  next_node: 0,
  cipher_length: 0,
  cipher: 0,
  modify_time: 0,
  creator: 0,
  modify_user: 0,
  acl: 0,
  title_length: 0,
  prop_length: 0,
  content_length: 0,
  title: 0,
  create_time: 0
};
_NODE_DATA_OFFSET.node_type = _NODE_DATA_OFFSET.block_size + 2;
_NODE_DATA_OFFSET.field = _NODE_DATA_OFFSET.node_type + 2;
_NODE_DATA_OFFSET.version = _NODE_DATA_OFFSET.field + 4;
_NODE_DATA_OFFSET.org_id = _NODE_DATA_OFFSET.version + 8;
_NODE_DATA_OFFSET.node_id = _NODE_DATA_OFFSET.org_id + 16;
_NODE_DATA_OFFSET.parent_id = _NODE_DATA_OFFSET.node_id + 16;
_NODE_DATA_OFFSET.first_child = _NODE_DATA_OFFSET.parent_id + 16;
_NODE_DATA_OFFSET.last_child = _NODE_DATA_OFFSET.first_child + 16;
_NODE_DATA_OFFSET.forward_node = _NODE_DATA_OFFSET.last_child + 16;
_NODE_DATA_OFFSET.next_node = _NODE_DATA_OFFSET.forward_node + 16;
_NODE_DATA_OFFSET.cipher_length = _NODE_DATA_OFFSET.create_time = _NODE_DATA_OFFSET.next_node + 16;
_NODE_DATA_OFFSET.cipher = _NODE_DATA_OFFSET.cipher_length + 4;
_NODE_DATA_OFFSET.modify_time = _NODE_DATA_OFFSET.create_time + 8;
_NODE_DATA_OFFSET.creator = _NODE_DATA_OFFSET.modify_time + 8;
_NODE_DATA_OFFSET.modify_user = _NODE_DATA_OFFSET.creator + 16;
_NODE_DATA_OFFSET.acl = _NODE_DATA_OFFSET.modify_user + 16;
_NODE_DATA_OFFSET.title_length = _NODE_DATA_OFFSET.acl + 2;
_NODE_DATA_OFFSET.prop_length = _NODE_DATA_OFFSET.title_length + 2;
_NODE_DATA_OFFSET.content_length = _NODE_DATA_OFFSET.prop_length + 4;
_NODE_DATA_OFFSET.title = _NODE_DATA_OFFSET.content_length + 4;
export const NODE_DATA_OFFSET = _NODE_DATA_OFFSET;